import { Stack, Text, Wrap, WrapItem } from "@chakra-ui/react";
import { DepartmentSelect } from "../common/DepartmentSelect";
import { RankingSelect } from "../common/RankingSelect";
import { TenureSelect } from "../common/TenureSelect";

export const EnpsReportFilters = ({
  departmentsToFilter,
  setDepartmentsToFilter,
  ranksToFilter,
  setRanksToFilter,
  tenuresToFilter,
  setTenuresToFilter,
}) => {
  return (
    <Stack direction={{ base: "column", sm: "row" }} alignItems={"center"}>
      <Text fontWeight={700} whiteSpace={"nowrap"}>
        Filtered by:
      </Text>
      <Wrap>
        <WrapItem>
          <DepartmentSelect
            selectedDepartments={departmentsToFilter}
            setSelectedDepartments={setDepartmentsToFilter}
          />
        </WrapItem>
        <WrapItem>
          <RankingSelect
            selectedRanks={ranksToFilter}
            setSelectedRanks={setRanksToFilter}
          />
        </WrapItem>
        <WrapItem>
          <TenureSelect
            selectedTenures={tenuresToFilter}
            setSelectedTenures={setTenuresToFilter}
            label={"Tenure"}
          />
        </WrapItem>
      </Wrap>
    </Stack>
  );
};
